<template>
            <div class="main-content no-padding noscroll" :class="{create_workflow_automation_page: $route.name === 'nodeData' || $route.name === 'EmailTemplate'}">
                <Loading v-show="loading"/>

                <router-view :integrations="integrations" v-if="integrations.length"/>

                <div class="funnel_apps layout-column noscroll" v-if="$route.name !== 'nodeData' && $route.name !== 'EmailTemplate'" :class="[$route.name]">
                     <div class="funnel_apps_header">
                        <h3>Automations <span class="panel_head_amount">({{automations.length}})</span></h3>
                        <a @click="showCreateAutomationPopup" class="btn">Create a new automation</a>
                    </div>
                    <div class=" scroll" style="width: 100%;">
                        <div class="funnel_apps_list panel funnels-panel automations_panel">
                            <div class="panel-body entries-table" v-if="integrations.length && automations.length">

                                <router-link class="panel-item entry"
                                    v-for="(item, index) in automations"
                                    :key="index + '_' + item.id"
                                    :to="'/funnel/'+ $route.params.id +'/automations/'+item.id">

                                    <div class="panel_item_left">
                                        <div class="products_panel_first_cell">
                                            <div class="automations_item">
                                                <div class="automations_item_img">
                                                    <img :src="require('@/assets/img/automation_workflow_icon.svg')" alt="">
                                                    <!-- <img :src="getTrigger(item.trigger_id).icon" alt=""> -->
                                                </div>
                                                <div class="cell-value">{{item.action_caption}}</div>
                                                <!-- <div class="cell-value">{{getTrigger(item.trigger_id)}}</div> -->
                                            </div>
                                        </div>
                                        <!-- <div class="panel-item-cell">
                                            <div class="cell-value">
                                                <inline-svg :src="require('@/assets/img/automations_arrow.svg')"/>
                                            </div>
                                        </div> -->
                                    </div>

                                    <div class="panel_item_right">
                                        <div class="automation-activation-group" @click.prevent="activateItem(item)">
                                            <div class="optin_email_checkbox">
                                                <span class="text_label" :class="{active: item.is_active}">{{ item.is_active ? 'Active' : 'Inactive' }}</span>
                                                <label class="switch_checkbox_item">
                                                    <input type="checkbox" :checked="item.is_active">
                                                    <div class="switch_checkbox"><span></span></div>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="panel_item_btn_wrpr ml_20">
                                            <a @click.stop.prevent="copyAutomation(item)" class="panel_item_btn copy_btn">
                                                <inline-svg :src="require('@/assets/img/copy_icon.svg')"/>
                                            </a>
                                            <a @click.prevent="showAutomationsDeletePopup(item)" class="panel_item_btn delete_btn">
                                                <inline-svg :src="require('@/assets/img/delete_icon.svg')"/>
                                            </a>
                                        </div>
                                    </div>

                                </router-link>

                            </div>
                            <p style="text-align: center;" v-else>No automations were created yet!</p>
                        </div>
                    </div>
                </div>
                <div class="popup_wrpr add_new_funnel_popup" :class="{active: getAutomationsDeletePopup}">
                    <AutomationsDeletePopup :automationItem="automationItem" @delete="deleteCurrentAutomation" v-if="getAutomationsDeletePopup"/>
                </div>

                <div class="popup_wrpr" :class="{active: getCreateAutomationPopup}">
                    <CreateAutomationPopup v-if="getCreateAutomationPopup"/>
                </div>

            </div>
</template>

<script>
import AutomationsDeletePopup from "@/components/popups/delete/AutomationsDeletePopup.vue"
import CreateAutomationPopup from "@/components/popups/automation/CreateAutomationPopup.vue"
import {mapGetters} from "vuex"
import API from "@/api"
import Loading from "@/components/Loading.vue"

export default {
    name: "FunnelAutomations",
    components: {
        AutomationsDeletePopup,
        CreateAutomationPopup,
        Loading,
    },
    mixins: [API],
    data: function() {
        return {
            automations: [],
            integrations: [],
            triggers: [
                {
					id: 1,
					icon: require('@/assets/img/tg-icon-2.svg'),
					text: "On Refund",
					name: "refund"
				},
				{
					id: 2,
					icon: require('@/assets/img/tg-icon-3.svg'),
					text: "New Subscription",
					name: "Subscribes to a list"
				},
				{
					id: 3,
					icon: require('@/assets/img/tg-icon-4.svg'),
					text: "Subscription Canceled",
					name: "unsubscribe"
				},
				{
					id: 4,
					icon: require('@/assets/img/tg-icon-1.svg'),
					text: "On Purchase",
					name: "purchase"
				},
				{
					id: 5,
					icon: require('@/assets/img/tg-icon-5.svg'),
					text: "Purchase attempt",
					name: "attempt"
				},
				{
					id: 6,
					icon: require('@/assets/img/tg-icon-6.svg'),
					text: "Optin",
					name: "optin"
            	},
            ],
            automationsItems: [
                {
                    id: '1',
                    leftItem: {
                        icon: require('@/assets/img/automations_subscription_canceled.png'),
                        title: 'Subscription Canceled'
                    },
                    rightItem: {
                        icon: require('@/assets/img/automations_right_item_1.png'),
                        title: 'Create an order',
                        subtitle: '1 x American Flag couple underwear'
                    }
                },
                {
                    id: '2',
                    leftItem: {
                        icon: require('@/assets/img/automations_on_purchase.png'),
                        title: 'On Purchase'
                    },
                    rightItem: {
                        icon: require('@/assets/img/automations_right_item_2.png'),
                        title: 'Create an order',
                    }
                },
                {
                    id: '3',
                    leftItem: {
                        icon: require('@/assets/img/automations_on_refund.png'),
                        title: 'On Refund'
                    },
                    rightItem: {
                        icon: require('@/assets/img/automations_right_item_3.png'),
                        title: 'Create an order',
                        subtitle: '1 x American Flag couple underwear'
                    }
                },
                {
                    id: '4',
                    leftItem: {
                        icon: require('@/assets/img/automations_subscription_canceled.png'),
                        title: 'New Subscription'
                    },
                    rightItem: {
                        icon: require('@/assets/img/automations_right_item_1.png'),
                        title: 'Remove from list',
                    }
                },
                {
                    id: '5',
                    leftItem: {
                        icon: require('@/assets/img/automations_optin.png'),
                        title: 'Optin'
                    },
                    rightItem: {
                        icon: require('@/assets/img/automations_right_item_add_tag.png'),
                        title: 'Add tag',
                        tags: ['Another Tag','label']
                    }
                },
                {
                    id: '6',
                    leftItem: {
                        icon: require('@/assets/img/automations_purchase_attempt.png'),
                        title: 'Purchase attempt'
                    },
                    rightItem: {
                        icon: require('@/assets/img/automations_right_item_4.png'),
                        title: 'Create an order',
                    }
                },
                {
                    id: '7',
                    leftItem: {
                        icon: require('@/assets/img/automations_right_item_1.png'),
                        title: 'On Refund'
                    },
                    rightItem: {
                        icon: require('@/assets/img/app_logo_3.png'),
                        title: 'Create an order',
                        subtitle: '1 x American Flag couple underwear'
                    }
                },
            ],
            stepData: [],
            funnel: {},
            loading: true,
            automationId: '',
            automationItem: {},
        };
    },
    computed: {
        notificationsOpen() {
            return this.$store.state.notificationsOpen;
        },
        ...mapGetters(["getAutomationsDeletePopup", "getCreateAutomationPopup", "getStepDataStore", "getFunnelStore"]),
    },
    methods: {
        async activateItem(item) {
            item.is_active = !item.is_active;
            var {id} = this.$route.params;
            var result = await this.api.automations.patch(id, item.id, item);
            console.log({result});
        },
        getTrigger(id) {
            var trigger = this.triggers.find(trig => trig.id === id);
            return trigger
        },
        getIntegration(id) {
            var intergation = this.integrations.find(integ => parseInt(integ.id) === id);
            return intergation
        },
        async deleteCurrentAutomation(thisItem){
            // let deleteItem = this.automationsItems.map(item => item.id).indexOf(thisId);
            // this.automationsItems.splice(deleteItem, 1);

            let data = {
                "id": thisItem.id,
                "funnel_id": thisItem.funnel_id,
                "user_id": thisItem.user_id
            }

            var result = await this.api.automations.delete(thisItem.funnel_id, data);
            this.$store.commit("closeAutomationsDeletePopup");

            this.init(this.$route.params.id);
        },
        showAutomationsDeletePopup(thisAutomationItem) {
            this.automationItem = thisAutomationItem;
            this.$store.commit("showAutomationsDeletePopup");
        },
        showCreateAutomationPopup() {
            // this.$notify({
            //     group: 'main',
            //     type: 'warn',
            //     duration: 6000,
            //     title: 'Important message',
            // });
            this.$store.commit("showCreateAutomationPopup");
        },
        async copyAutomation(item){
            var {id} = this.$route.params;
            var result = await this.api.automations.create(id, item);
            console.log({result});
            this.init(id);
        },
        async init(id) {
        	// FIXME: Stop loading integrations here, only do that when customer is in the popup.
            var response = await this.getIntegrations();
            this.integrations = response.data;

            //console.log('get funnel automations: ', id);
            this.automations = await this.api.automations.get(id);

            //console.log({automations: this.automations, integrations: this.integrations});

            this.$nextTick(()=>this.loading = false);
        }
    },
    created() {
        var {id} = this.$route.params
        this.init(id);

        this.$router.beforeEach((to, from, next) => {
            // console.log('router.beforeEach:', from);
            if (from.name == "nodeData") {
                next()
                this.loading = true;
                this.init(id);
            } else {
                next()
            }

        })
        //console.log('$route: ', this.$route);

        // this.$notify({
        //     group: 'main',
        //     type: 'warn',
        //     title: 'Important message',
        //     duration: 6000,
        //     text: 'Test notification'
        // })

    }
}
</script>

<style scoped>
.loading {
    height: calc(100vh - 71px);
}
</style>

<style>
.automations_panel .panel-item-cell {
    width: auto;
}
.sender_details_popup .form_input_email_icon .icon, .sender_details_popup .form_input_user_icon .icon {
    width: auto;
    height: auto;
}
.template_type_popup .atn-trigger-items .item .icon {
    width: auto;
    height: auto;
}
</style>
